package com.nonopn.skywatcher.design.widgets.popup

import com.nonopn.skywatcher.app.utils.Queue
import eu.codlab.viewmodel.StateViewModel
import eu.codlab.viewmodel.launch
import korlibs.io.util.UUID

data class PopupStateHolder(
    val uuid: String = UUID.randomUUID().toString(),
    var title: String = "",
    var text: String = "",
    val onConfirm: () -> Unit = {},
    val onDismiss: (() -> Unit)? = null
)

data class PopupLocalModelState(
    var show: Boolean = false,
    val invocations: List<PopupStateHolder> = mutableListOf()
)

class PopupLocalModel : StateViewModel<PopupLocalModelState>(PopupLocalModelState()) {
    private val queue = Queue(viewModelScope)
    fun show(
        title: String,
        text: String,
        onDismiss: (() -> Unit)? = null,
        onConfirm: () -> Unit = {}
    ) = launch {
        queue.enqueue {
            val uuid = UUID.randomUUID().toString()

            updateState {
                copy(
                    show = true,
                    invocations = invocations + PopupStateHolder(
                        uuid = uuid,
                        title = title,
                        text = text,
                        onDismiss = {
                            dismiss(uuid)

                            onDismiss?.invoke()
                        },
                        onConfirm = onConfirm
                    )
                )
            }
        }
    }

    fun dismiss(uuid: String) = launch {
        queue.enqueue {
            val newInvocations = states.value.invocations.filter { it.uuid != uuid }

            updateState {
                copy(
                    show = newInvocations.isNotEmpty(),
                    invocations = newInvocations
                )
            }
        }
    }
}
